import { render } from "./TradeSelect.vue?vue&type=template&id=0393477f&scoped=true&ts=true"
import script from "./TradeSelect.vue?vue&type=script&lang=ts"
export * from "./TradeSelect.vue?vue&type=script&lang=ts"

import "./TradeSelect.vue?vue&type=style&index=0&id=0393477f&scoped=true&lang=css"

import exportComponent from "D:\\projects\\wintick\\wintick-applets-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0393477f"]])

export default __exports__